var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "step2" },
    [
      _c(
        "b-form",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "4" } },
                [
                  _c("b-card", { staticClass: "shadow-none border" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-between",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("b-form-checkbox", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.facebookChecked,
                                callback: function ($$v) {
                                  _vm.facebookChecked = $$v
                                },
                                expression: "facebookChecked",
                              },
                            }),
                            _c("h4", { staticClass: "mb-0" }, [
                              _vm._v("Facebook"),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c("feather-icon", {
                              staticClass: "text-info",
                              attrs: { icon: "FacebookIcon", size: "25" },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "4" } },
                [
                  _c("b-card", { staticClass: "shadow-none border" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-between",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("b-form-checkbox", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.instagramChecked,
                                callback: function ($$v) {
                                  _vm.instagramChecked = $$v
                                },
                                expression: "instagramChecked",
                              },
                            }),
                            _c("h4", { staticClass: "mb-0" }, [
                              _vm._v("Instagram"),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c("feather-icon", {
                              staticClass: "text-danger",
                              attrs: { icon: "InstagramIcon", size: "25" },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "4" } },
                [
                  _c("b-card", { staticClass: "shadow-none border" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-between",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("b-form-checkbox", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.linkedinChecked,
                                callback: function ($$v) {
                                  _vm.linkedinChecked = $$v
                                },
                                expression: "linkedinChecked",
                              },
                            }),
                            _c("h4", { staticClass: "mb-0" }, [
                              _vm._v("LinkedIn"),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c("feather-icon", {
                              staticClass: "text-info text-darken-2",
                              attrs: { icon: "LinkedinIcon", size: "25" },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c("h4", [_vm._v("Post Details")]),
                  _vm.facebookChecked &&
                  _vm.instagramChecked &&
                  _vm.linkedinChecked
                    ? _c(
                        "b-form-checkbox",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            name: "check-button",
                            switch: "",
                            inline: "",
                          },
                          model: {
                            value: _vm.isSwitchChecked,
                            callback: function ($$v) {
                              _vm.isSwitchChecked = $$v
                            },
                            expression: "isSwitchChecked",
                          },
                        },
                        [
                          _vm._v(
                            " Customise post for Facebook, Instagram, and LinkedIn "
                          ),
                        ]
                      )
                    : _vm.facebookChecked && _vm.instagramChecked
                    ? _c(
                        "b-form-checkbox",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            name: "check-button",
                            switch: "",
                            inline: "",
                          },
                          model: {
                            value: _vm.isSwitchChecked,
                            callback: function ($$v) {
                              _vm.isSwitchChecked = $$v
                            },
                            expression: "isSwitchChecked",
                          },
                        },
                        [_vm._v(" Customise post for Facebook and Instagram ")]
                      )
                    : _vm.facebookChecked && _vm.linkedinChecked
                    ? _c(
                        "b-form-checkbox",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            name: "check-button",
                            switch: "",
                            inline: "",
                          },
                          model: {
                            value: _vm.isSwitchChecked,
                            callback: function ($$v) {
                              _vm.isSwitchChecked = $$v
                            },
                            expression: "isSwitchChecked",
                          },
                        },
                        [_vm._v(" Customise post for Facebook and LinkedIn ")]
                      )
                    : _vm.instagramChecked && _vm.linkedinChecked
                    ? _c(
                        "b-form-checkbox",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            name: "check-button",
                            switch: "",
                            inline: "",
                          },
                          model: {
                            value: _vm.isSwitchChecked,
                            callback: function ($$v) {
                              _vm.isSwitchChecked = $$v
                            },
                            expression: "isSwitchChecked",
                          },
                        },
                        [_vm._v(" Customise post for Instagram and LinkedIn ")]
                      )
                    : _vm._e(),
                  _vm.isSwitchChecked
                    ? _c(
                        "b-tabs",
                        [
                          _vm.facebookChecked
                            ? _c(
                                "b-tab",
                                { attrs: { title: "Facebook" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Facebook Description",
                                        "label-for": "description",
                                      },
                                    },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          rules: "required",
                                          name: "Facebook Post",
                                          vid: "Description",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c("quill-editor", {
                                                    attrs: {
                                                      state:
                                                        errors.length > 0
                                                          ? false
                                                          : null,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.campaignIdss
                                                          .description,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.campaignIdss,
                                                          "description",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "campaignIdss.description",
                                                    },
                                                  }),
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [_vm._v(_vm._s(errors[0]))]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1935705694
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.instagramChecked
                            ? _c(
                                "b-tab",
                                { attrs: { title: "Instagram" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Instagram Description",
                                        "label-for": "description",
                                      },
                                    },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          rules: "required",
                                          name: "Instagram Post",
                                          vid: "Description",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c("quill-editor", {
                                                    attrs: {
                                                      state:
                                                        errors.length > 0
                                                          ? false
                                                          : null,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.campaignIdss
                                                          .description,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.campaignIdss,
                                                          "description",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "campaignIdss.description",
                                                    },
                                                  }),
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [_vm._v(_vm._s(errors[0]))]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1935705694
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.linkedinChecked
                            ? _c(
                                "b-tab",
                                { attrs: { title: "LinkedIn" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "LinkedIn Description",
                                        "label-for": "description",
                                      },
                                    },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          rules: "required",
                                          name: "LinkedIn Post",
                                          vid: "Description",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c("quill-editor", {
                                                    attrs: {
                                                      state:
                                                        errors.length > 0
                                                          ? false
                                                          : null,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.campaignIdss
                                                          .description,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.campaignIdss,
                                                          "description",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "campaignIdss.description",
                                                    },
                                                  }),
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [_vm._v(_vm._s(errors[0]))]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1935705694
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Description",
                            "label-for": "description",
                          },
                        },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              name: "email content",
                              vid: "Description",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("quill-editor", {
                                      attrs: {
                                        state: errors.length > 0 ? false : null,
                                        disabled: "",
                                      },
                                      model: {
                                        value: _vm.campaignIdss.description,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.campaignIdss,
                                            "description",
                                            $$v
                                          )
                                        },
                                        expression: "campaignIdss.description",
                                      },
                                    }),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                ],
                1
              ),
              _c("b-col", { attrs: { md: "12" } }, [
                _c(
                  "div",
                  { staticClass: "demo-inline-spacing" },
                  [
                    _c(
                      "b-form-radio",
                      {
                        attrs: { name: "radio1", value: "D", disabled: "" },
                        on: {
                          change: function ($event) {
                            return _vm.emitAction("draft")
                          },
                        },
                        model: {
                          value: _vm.SelectedRadio,
                          callback: function ($$v) {
                            _vm.SelectedRadio = $$v
                          },
                          expression: "SelectedRadio",
                        },
                      },
                      [_vm._v(" Save as Draft ")]
                    ),
                    _c(
                      "b-form-radio",
                      {
                        attrs: { name: "radio1", value: "A", disabled: "" },
                        on: {
                          change: function ($event) {
                            return _vm.emitAction("sendNow")
                          },
                        },
                        model: {
                          value: _vm.SelectedRadio,
                          callback: function ($$v) {
                            _vm.SelectedRadio = $$v
                          },
                          expression: "SelectedRadio",
                        },
                      },
                      [_vm._v(" Send Now ")]
                    ),
                    _c(
                      "b-form-radio",
                      {
                        attrs: { name: "radio1", value: "B", disabled: "" },
                        on: {
                          change: function ($event) {
                            return _vm.emitAction("schedule")
                          },
                        },
                        model: {
                          value: _vm.SelectedRadio,
                          callback: function ($$v) {
                            _vm.SelectedRadio = $$v
                          },
                          expression: "SelectedRadio",
                        },
                      },
                      [_vm._v(" Schedule Sending ")]
                    ),
                  ],
                  1
                ),
              ]),
              _vm.SelectedRadio === "B"
                ? _c(
                    "b-col",
                    { staticClass: "mt-2", attrs: { md: "12" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _vm.facebookChecked
                                ? _c(
                                    "b-form-group",
                                    { staticClass: "mb-1" },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          rules: "required",
                                          name: "date and time",
                                          vid: "dateNtim",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex align-items-end mb-1",
                                                    },
                                                    [
                                                      _c("feather-icon", {
                                                        staticClass:
                                                          "text-info",
                                                        attrs: {
                                                          icon: "FacebookIcon",
                                                          size: "18",
                                                        },
                                                      }),
                                                      _c(
                                                        "h5",
                                                        {
                                                          staticClass:
                                                            "ml-1 mb-0",
                                                        },
                                                        [_vm._v("Facebook")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c("b-form-datepicker", {
                                                    attrs: {
                                                      id: "form-control",
                                                      placeholder:
                                                        "Choose a date",
                                                      local: "en",
                                                      "initial-date":
                                                        new Date(),
                                                      min: _vm.today,
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.campaignIdss
                                                          .scheduledPublishedDate,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.campaignIdss,
                                                          "scheduledPublishedDate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "campaignIdss.scheduledPublishedDate",
                                                    },
                                                  }),
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [_vm._v(_vm._s(errors[0]))]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3131556647
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("b-col", { attrs: { md: "4" } }),
                          _c("b-col", { attrs: { md: "4" } }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }